export default __webpack_public_path__ + "static/media/kivich49.29284a31.png";